import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { FormField } from "../../../../sharedComponents/formField";
import { NotificationManager } from "react-notifications";

import { declineRecipe } from "../../../../store/actions/index";
import { PanelBody, PanelFooter } from "../../../../sharedComponents/filterPanel";
import { required } from "../../../../constants/formValidators";
import { declineCodes } from "../../../../constants/recipeConstants";

const DeclineRecipePanel = ({ data, handleSubmit, declineRecipe, onUpdate, onError, resetForm }) => {
	const validateForm = (values) => {
		const successHandler = () => {
			NotificationManager.success("Recipe declined!", "", 5000);
			onUpdate();
			resetForm("DeclineRecipePanel");
		};
		const errorHandler = () => {
			NotificationManager.error("Recipe not declined! Please try again.", "", 5000);
			onError();
		};
		declineRecipe({ ...values, id: data.id }, successHandler, errorHandler);
	};

	return (
		<form className="advanced-filter-form" onSubmit={handleSubmit(validateForm)}>
			<PanelBody>
				<div className="row">
					<div className="col-12">
						<Field
							label="Decline code"
							name="decline_code"
							type="select"
							options={declineCodes}
							component={FormField}
							validate={[required]}
						/>
					</div>
				</div>
			</PanelBody>
			<PanelFooter className="pt-0">
				<div className="text-right pt-3">
					<button className="btn btn-primary-dark text-uppercase" type="submit">
						Decline
					</button>
				</div>
			</PanelFooter>
		</form>
	);
};

const mapDispatchToProps = {
	declineRecipe,
	resetForm: reset
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "DeclineRecipePanel",
		enableReinitialize: true
	})(DeclineRecipePanel)
);
